import React from 'react';
import { Subscriber } from 'types/electionService';
import { NoDependentsMessageStyled, SubscriberDependentsContentStyled } from './styles';
import DependentBlock from './DependentBlock';

export interface SubscriberDependentsProps {
  subscriber: Subscriber;
}

const SubscriberDependents = ({ subscriber }: SubscriberDependentsProps): JSX.Element => {
  return (
    <SubscriberDependentsContentStyled>
      {subscriber.custom.dependents.length > 0 ? (
        subscriber.custom.dependents.map((dependent) => {
          return <DependentBlock key={dependent.id} dependent={dependent} />;
        })
      ) : (
        <NoDependentsMessageStyled>No dependents</NoDependentsMessageStyled>
      )}
    </SubscriberDependentsContentStyled>
  );
};

export default SubscriberDependents;
